import * as yup from 'yup';

const REQUIRED_FIELD_TEXT = "Field cannot be empty";

export const passwordSchema = yup
    .string()
    .min(8, 'Password must have at least 8 characters')
    .matches(/[0-9]/, 'Password must contains at least one number')
    .matches(/[a-z]/, 'Password must contains at least one lowercase letter')
    .matches(/[A-Z]/, 'Password must contains at least one uppercase letter')
    .matches(/[^\w_]/, 'Password must contains at least one special character')
    .required(REQUIRED_FIELD_TEXT);